import { GlobalAlert } from '@thoughtspot/global-alert';
import { useTranslation } from '@thoughtspot/i18n';
import { BannerAlertType } from '@thoughtspot/radiant-react/widgets/alert/banner/banner-alert';
import React, { createContext, useContext, useEffect, useMemo, useReducer, useState, } from 'react';
import { useSetupNavService, } from "../services/system/nav-service/nav-service";
const NavigationContext = createContext({});
export const useNavigationContext = () => useContext(NavigationContext);
export const NavigationContextProvider = ({ children, }) => {
    const navService = useSetupNavService();
    return (React.createElement(NavigationContext.Provider, { value: {
            navService,
        } }, children));
};
export var ReducerActionType;
(function (ReducerActionType) {
    ReducerActionType[ReducerActionType["SET_GLOBAL_ALERT"] = 0] = "SET_GLOBAL_ALERT";
    ReducerActionType[ReducerActionType["SET_GLOBAL_RESET"] = 1] = "SET_GLOBAL_RESET";
})(ReducerActionType || (ReducerActionType = {}));
const reducer = (state, action) => {
    switch (action.type) {
        case ReducerActionType.SET_GLOBAL_ALERT: {
            return {
                ...state,
                alertProps: action.payload,
            };
        }
        case ReducerActionType.SET_GLOBAL_RESET: {
            return {
                ...state,
                alertProps: {
                    isVisible: false,
                    message: '',
                    type: BannerAlertType.INFO,
                },
            };
        }
        default:
            return state;
    }
};
export const AdminContext = createContext({});
export const useAdminContext = () => useContext(AdminContext);
export const AdminContextProvider = ({ children, rootPath, ...rest }) => {
    const [state, dispatch] = useReducer(reducer, { rootPath, ...rest });
    const { t } = useTranslation();
    const onError = (error) => {
        const message = t('error.validation.default');
        dispatch({
            type: ReducerActionType.SET_GLOBAL_ALERT,
            payload: {
                isVisible: true,
                message,
                type: BannerAlertType.ERROR,
            },
        });
    };
    const contextValue = useMemo(() => {
        return { state, dispatch, onError, rootPath, ...rest };
    }, [state, dispatch]);
    return (React.createElement(AdminContext.Provider, { value: contextValue },
        React.createElement(GlobalAlert.Banner, { isVisible: contextValue.state?.alertProps?.isVisible, message: contextValue.state?.alertProps?.message, type: contextValue.state?.alertProps?.type, onClose: () => dispatch({
                type: ReducerActionType.SET_GLOBAL_RESET,
                payload: null,
            }) }),
        children));
};
export const AdminEditedPageLeaveContext = createContext({});
export const useAdminEditedPageLeaveContext = () => useContext(AdminEditedPageLeaveContext);
export const AdminEditedPageLeaveContextProvider = ({ children, }) => {
    const [edit, setEdit] = useState(false);
    const [sideTabClicked, setSideTabClicked] = useState(false);
    useEffect(() => {
        const handleSidebarClick = () => {
            setSideTabClicked(true);
        };
        window.addEventListener('admin:sidebar-clicked', handleSidebarClick);
        return () => {
            window.removeEventListener('admin:sidebar-clicked', handleSidebarClick);
        };
    }, []);
    const isEdited = (edited) => {
        if (edited) {
            setEdit(true);
            window.dispatchEvent(new CustomEvent('admin:unsaved-changes', {
                detail: { hasChanges: true },
            }));
        }
    };
    const isNotEdited = () => {
        setEdit(false);
        window.dispatchEvent(new CustomEvent('admin:unsaved-changes', {
            detail: { hasChanges: false },
        }));
    };
    const onUnSaveClick = () => {
        setSideTabClicked(true);
        window.dispatchEvent(new CustomEvent('admin:sidebar-clicked'));
    };
    const onSaveClick = () => {
        setSideTabClicked(false);
    };
    return (React.createElement(AdminEditedPageLeaveContext.Provider, { value: {
            edit,
            isEdited,
            isNotEdited,
            sideTabClicked,
            onUnSaveClick,
            onSaveClick,
        } }, children));
};
//# sourceMappingURL=context.js.map